function language() {
  return localStorage.getItem("language")
    ? localStorage.getItem("language")
    : "vi";
}
export default function timeSince(date) {
  var seconds = Math.floor((new Date() - Date.parse(date)) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return (
      Math.floor(interval) + (language() == "vi" ? " năm trước" : " years ago")
    );
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return (
      Math.floor(interval) +
      (language() == "vi" ? " tháng trước" : " months ago")
    );
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return (
      Math.floor(interval) + (language() == "vi" ? " ngày trước" : " days ago")
    );
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return (
      Math.floor(interval) + (language() == "vi" ? " giờ trước" : " hours ago")
    );
  }
  interval = seconds / 60;
  if (interval > 1) {
    return (
      Math.floor(interval) +
      (language() == "vi" ? " phút trước" : " minutes ago")
    );
  }
  return (
    Math.floor(seconds) + (language() == "vi" ? " giây trước" : " seconds ago")
  );
}

export function timeDuration(from, to) {
  var seconds = Math.floor((Date.parse(to) - Date.parse(from)) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + (language() == "vi" ? " năm" : " years");
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + (language() == "vi" ? " tháng" : " months");
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + (language() == "vi" ? " ngày" : " days");
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + (language() == "vi" ? " giờ" : " hours");
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + (language() == "vi" ? " phút" : " minutes");
  }
  return Math.floor(seconds) + (language() == "vi" ? " giây" : " seconds");
}
